import { User, Loader2 } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { useAvatarUrl } from '../hooks';

interface ChatAvatarProps {
  chatId: number;
  title: string;
  className?: string;
}

export function ChatAvatar({ chatId, title, className }: ChatAvatarProps) {
  const initials = title.charAt(0).toUpperCase();
  const { url, isLoading, error } = useAvatarUrl(chatId);

  return (
    <Avatar className={cn('flex-shrink-0', className)}>
      {isLoading && (
        <div className="w-full h-full flex items-center justify-center bg-primary/10">
          <Loader2 className="h-4 w-4 animate-spin text-primary" />
        </div>
      )}
      {url && !error && (
        <AvatarImage
          src={url}
          alt={title}
        />
      )}
      <AvatarFallback className="bg-primary/10 text-primary font-semibold">
        {initials || <User className="h-5 w-5" />}
      </AvatarFallback>
    </Avatar>
  );
}
